import React, {useState} from "react";
import IconButton from '@mui/material/IconButton';
import TrafficlightButtonOrange from "../../../../../../../components/Button/TrafficlightButtonOrange";
import CustomDialog from "../../../../../../../components/Dialog/DiaComp";
import { TextSignalRenin } from "./TextSignalRenin";

export default function Renin_Signal() {

const [open, setOpen] = useState(false);
const handleOpen = () => {setOpen(true);};
const handleClose = () => {setOpen(false);};

return(
<>      

<IconButton onClick={handleOpen}>
    <TrafficlightButtonOrange  />
</IconButton>

<CustomDialog open={open} onClose={handleClose}

    title='Renin-Angiotensin-System (RAS) - Analysis'

    content={ <TextSignalRenin />}

/>

</>
)}